<template>
  <div class="auth_main__wrapper">
    <div class="auth_main__page">
      <div class="left-block">
        <div class="auth_img">
          <img src="../assets/img/authentication-image.svg" />
          <img src="../assets/img/codelos-logo.svg" class="logo" />
        </div>
      </div>

      <LoginForm
        v-if="currentOpenForm === 'login'"
        :message="message"
        @onResetPassword="onTooglePasswordResetForm"
        @onNewPassword="onToogleNewPasswordForm"
      />
      <PasswordResetForm
        v-if="currentOpenForm === 'reset'"
        @onBack="onTooglePasswordResetForm"
      />
      <NewPasswordForm
        v-if="currentOpenForm === 'newPassword'"
        :userDetail="userDetail"
        @onBack="onToogleNewPasswordForm"
      />
    </div>
    <div class="footer-link">
      <section>
        <ul class="inline-list">
          <li>
            <router-link to="/impressum">Impressum</router-link>
          </li>
          <li>
            <router-link to="/privacy">Datenschutzerklärung</router-link>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
import LoginForm from '../components/auth/LoginForm.vue';
import PasswordResetForm from '../components/auth/PasswordResetForm.vue';
import NewPasswordForm from '../components/auth/NewPasswordForm.vue';

export default {
  name: 'AuthPage',
  props: ['message'],
  data() {
    return {
      currentOpenForm: 'login',
      userDetail: null,
    };
  },
  methods: {
    onTooglePasswordResetForm() {
      this.currentOpenForm =
        this.currentOpenForm === 'reset' ? 'login' : 'reset';
    },
    onToogleNewPasswordForm(user) {
      if (this.currentOpenForm === 'login' && !user) return;
      this.userDetail = user || null;

      this.currentOpenForm =
        this.currentOpenForm === 'newPassword' ? 'login' : 'newPassword';
    },
  },
  components: {
    LoginForm,
    PasswordResetForm,
    NewPasswordForm,
  },
};
</script>
<style scoped>
.auth_main__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.auth_main__wrapper .auth_main__page {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  height: 100%;
  width: 100%;
  max-width: 100%;
}
.auth_main__wrapper .auth_main__page .left-block {
  height: 100%;
  background-color: #eefcff;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth_main__wrapper .auth_main__page .auth_img {
  position: relative;
}

.auth_main__wrapper .auth_main__page .auth_img img {
  width: 100%;
  max-width: 380px;
}

.auth_main__wrapper .auth_main__page .auth_img .logo {
  position: absolute;
  left: 0;
  top: -75px;
  width: 155px;
}

.auth_main__wrapper .footer-link {
  position: fixed;
  bottom: 0;
  right: 0;
}

.auth_main__wrapper .footer-link .inline-list {
  list-style: unset;
}

.auth_main__wrapper .footer-link .inline-list li {
  display: inline-block;
  margin-right: 15px;
}

.auth_main__wrapper .footer-link .inline-list li a {
  color: black;
}

.auth_main__wrapper .footer-link .inline-list li a:hover {
  text-decoration: underline;
}

/* media query */
@media (max-width: 1024px) {
  .auth_main__wrapper .auth_main__page .left-block {
    display: none;
  }
  .auth_main__wrapper .auth_main__page {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
